export default __webpack_public_path__ + "static/media/artorias--side--240.d93ba449.jpg";